import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  container: {
    backgroundColor: theme.palette.background.primary,
    margin: '30px 0',
    borderRadius: 20,
    boxShadow: `0px 0px 38px ${theme.palette.common.blackShade}`,
    textAlign: 'center',
    paddingBottom: 5
  },
  heading: {
    backgroundColor: theme.palette.primary.main2,
    width: '50%',
    padding: 10,
    borderRadius: '20px 20px 20px 0',
    textAlign: 'center'
  },
  headingBlack: {
    backgroundColor: theme.palette.common.black,
    width: '50%',
    padding: 10,
    borderRadius: '20px 20px 20px 0',
    textAlign: 'center'
  },
  text: {
    color: theme.palette.common.black,
    fontWeight: 'bold'
  },
  textWhite: {
    color: theme.palette.common.white,
    fontWeight: 'bold'
  },
  form: {
    margin: 25,
    alignItems: 'center'
  },
  labelText: {
    textAlign: 'left',
    marginLeft: '4%',
    fontSize: '15px',
    fontWeight: '500',
    marginTop: '10px'
  },
  section: {
    textAlign: 'left',
    height: '300px',
    // overflowY: 'scroll'
  },
  headingText:{
    marginBottom :"0.5rem",
    color:" #455560",
    fontWeight:"500",
    fontSize:"17px"
   
  },
  typography:{
    color: "#455560",
    fontSize:"14px"
    // fontWeight: 'bold'
  },
  headingTextOrder:{
    marginBottom :"0.5rem",
    color:" black",
    fontWeight:"500",
    fontSize:"17px"
   
  },
  typographyOrder:{
    color: "black",
    fontSize:"14px"
    // fontWeight: 'bold'
  },
  
}))

export default useStyles
